import { Action, Connector, TaskItem, AutomationTaskEdit, AutomationTask } from './types';

export const isTaskAuthenticated = (
    task: AutomationTaskEdit,
    connectors: Record<string, Connector>,
) => {
    if (task.trigger && !isItemAuthenticated(task.trigger, connectors[task.trigger.connectorId])) {
        return false;
    }

    for (const action of task.actions) {
        if (!isItemAuthenticated(action, connectors[action.connectorId])) {
            return false;
        }
    }

    return true;
};

export const isItemAuthenticated = (taskItem: TaskItem, connector: Connector) => {
    // Connectors with Basic, ApiKey or Custom auth no longer have 'oAuthScopeDelimiter' and 'authorizedScopes',
    // instead they will have 'authorized'.
    const { oAuthScopeDelimiter, authorizedScopes, $t, authorized } = connector;

    if (oAuthScopeDelimiter && authorizedScopes) {
        return taskItem.scope
            .split(oAuthScopeDelimiter)
            .every((scope) => authorizedScopes.includes(scope));
    }

    if (
        $t.toUpperCase() === 'BASIC' ||
        $t.toUpperCase() === 'APIKEY' ||
        $t.toUpperCase() === 'CUSTOM'
    ) {
        return authorized;
    }

    return false;
};

export const uniqueConnectorIdsFromActions = (actions: Action[]): string[] => {
    const connectorIds: string[] = actions.map((action) => action.connectorId);
    return Array.from(new Set(connectorIds));
};

export const getCombinedMinutesSaved = (task: AutomationTask) => {
    let totalEstimatedTimeSaved = 0;

    if (task.trigger) {
        totalEstimatedTimeSaved += task.trigger?.estimatedMinutesSaved * task.activations;
    }

    task.actions.forEach((action) => {
        totalEstimatedTimeSaved += action.estimatedMinutesSaved * task.activations;
    });

    return totalEstimatedTimeSaved;
};

export const getAllCombinedMinutesSaved = (tasks: AutomationTask[]) => {
    let totalEstimatedTimeSaved = 0;

    tasks.forEach((task) => {
        totalEstimatedTimeSaved += getCombinedMinutesSaved(task);
    });

    return totalEstimatedTimeSaved;
};
